var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{class:_vm.wrapClass},[_c('div',{staticClass:"cursor cursor--small"}),_vm._v(" "),_c('canvas',{staticClass:"cursor cursor--canvas",attrs:{"resize":""}}),_vm._v(" "),_c('IntroBox',{attrs:{"trigger":_vm.trigger}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4caa632","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/FrontPage/FrontPage.vue
// module id = null
// module chunks = 